import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Cross, Phone, ShoppingCart, MessageCircle, MapPin, Mail, Clock, Menu, X, Search, ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";
import { useCart } from "./CartContext";
import ChatWidget from "./ChatWidget";

export const SHOP = {
  name: "Trustmeds Pharma",
  tagline: "Aapki Sehat, Hamara Bharosa",
  phone: "7428811670",
  phoneDisplay: "+91 74288 11670",
  whatsapp: "https://wa.me/917428811670?text=Namaste%20Trustmeds%20Pharma,%20mujhe%20medicine%20order%20karni%20hai.",
  email: "komalsani08@gmail.com",
  address: "Laxmipur Patti, Ward no. 08, Block no. N078, Kashipur, Udham Singh Nagar, Uttarakhand - 244713",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Laxmipur+Patti+Ward+8+Kashipur+Uttarakhand+244713",
  hours: "Mon – Sun: 8:00 AM – 10:00 PM",
};

const NAV = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/store/shop", label: "Shop", testid: "nav-link-shop" },
  { to: "/store/offers", label: "Offers", testid: "nav-link-offers" },
  { to: "/store/blog", label: "Blog", testid: "nav-link-blog" },
  { to: "/store/track", label: "Track Order", testid: "nav-link-track" },
  { to: "/store/about", label: "About", testid: "nav-link-about" },
  { to: "/store/contact", label: "Contact", testid: "nav-link-contact" },
];

export default function StoreLayout() {
  const { count, total } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const [q, setQ] = useState("");
  const [cats, setCats] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/categories`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setCats)
      .catch(() => {});
  }, []);
  const [installEvt, setInstallEvt] = useState(null);
  const [installDismissed, setInstallDismissed] = useState(() => localStorage.getItem("tm_install_dismissed") === "1");
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  const installApp = async () => {
    if (!installEvt) return;
    installEvt.prompt();
    await installEvt.userChoice;
    setInstallEvt(null);
  };
  const navigate = useNavigate();
  const doSearch = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/store/shop?q=${encodeURIComponent(q.trim())}`);
  };

  const linkCls = ({ isActive }) =>
    `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-emerald-50 text-emerald-900" : "text-slate-600 hover:text-emerald-900 hover:bg-emerald-50/60"}`;

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <div className="bg-[#064E3B] text-emerald-50 text-xs sm:text-sm text-center px-4 py-2">
        Same-day local delivery in Kashipur • Order on WhatsApp: <a href={SHOP.whatsapp} target="_blank" rel="noreferrer" className="font-semibold underline underline-offset-2">{SHOP.phoneDisplay}</a>
      </div>

      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-slate-200/80 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-3">
          <Link to="/store" className="flex items-center gap-2.5 shrink-0" data-testid="store-brand">
            <span className="w-9 h-9 rounded-xl bg-[#064E3B] flex items-center justify-center"><Cross className="w-5 h-5 text-emerald-300" /></span>
            <span>
              <span className="font-display font-extrabold text-slate-900 leading-none block">Trustmeds Pharma</span>
              <span className="text-[10px] text-emerald-700 font-semibold tracking-wide uppercase">Kashipur, Uttarakhand</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => n.to === "/store/shop" ? (
              <div key={n.to} className="relative group">
                <NavLink to={n.to} className={linkCls} data-testid={n.testid}>
                  Shop <ChevronDown className="inline-block w-3.5 h-3.5 ml-0.5 -mt-0.5 transition-transform group-hover:rotate-180" />
                </NavLink>
                <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-150 absolute left-1/2 -translate-x-1/2 top-full pt-2 z-50" data-testid="shop-category-dropdown">
                  <div className="bg-white border border-slate-200 rounded-2xl shadow-xl p-4 w-[540px] grid grid-cols-3 gap-x-4 gap-y-3">
                    <Link to="/store/shop" data-testid="dropdown-cat-all" className="text-sm font-bold text-emerald-800 hover:text-emerald-600 transition-colors">All Products →</Link>
                    {cats.map((c) => (
                      <div key={c.name} className="min-w-0">
                        <Link to={`/store/shop?cat=${encodeURIComponent(c.name)}`} data-testid={`dropdown-cat-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                          className="block text-sm font-bold text-slate-800 hover:text-emerald-700 transition-colors truncate">
                          {c.name}
                          {c.product_count > 0 && <span className="ml-1 text-[10px] font-semibold text-slate-400">({c.product_count})</span>}
                        </Link>
                        {c.children?.length > 0 && (
                          <div className="mt-1 space-y-0.5">
                            {c.children.map((s) => (
                              <Link key={s.name} to={`/store/shop?cat=${encodeURIComponent(c.name)}&sub=${encodeURIComponent(s.name)}`}
                                data-testid={`dropdown-sub-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                                className="block text-xs text-slate-500 hover:text-emerald-700 transition-colors truncate">
                                {s.name}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkCls} data-testid={n.testid}>{n.label}</NavLink>
            ))}
          </nav>

          <form onSubmit={doSearch} className="hidden lg:flex flex-1 max-w-sm mx-3">
            <div className="relative w-full">
              <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Medicines search karein…" data-testid="header-search-input"
                className="w-full h-10 pl-10 pr-4 rounded-full border border-slate-300 bg-slate-50 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            </div>
          </form>

          <div className="flex items-center gap-2">
            <a href={`tel:+91${SHOP.phone}`} className="hidden sm:flex items-center gap-2 text-sm font-semibold text-emerald-900 hover:text-emerald-700 px-2" data-testid="nav-call-link">
              <Phone className="w-4 h-4" /> {SHOP.phoneDisplay}
            </a>
            <Link to="/store/cart" className="relative flex items-center gap-2 bg-[#064E3B] hover:bg-[#043B2C] text-white text-sm font-semibold px-3.5 py-2 rounded-full transition-colors" data-testid="nav-cart-button">
              <ShoppingCart className="w-4 h-4" />
              <span className="hidden sm:inline">₹{total.toFixed(0)}</span>
              {count > 0 && <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-amber-500 text-white text-[10px] font-bold flex items-center justify-center" data-testid="nav-cart-count">{count}</span>}
            </Link>
            <button className="md:hidden p-2 text-slate-700" onClick={() => setMenuOpen(!menuOpen)} data-testid="nav-menu-toggle">
              {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
        {menuOpen && (
          <nav className="md:hidden border-t border-slate-100 bg-white px-4 py-2 flex flex-col" data-testid="nav-mobile-menu">
            {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setMenuOpen(false)} className={linkCls} data-testid={`${n.testid}-mobile`}>{n.label}</NavLink>)}
            {cats.length > 0 && (
              <div className="mt-2 pt-2 border-t border-slate-100" data-testid="mobile-category-list">
                <div className="px-3 pb-1 text-[10px] font-bold uppercase tracking-widest text-slate-400">Categories</div>
                {cats.map((c) => (
                  <div key={c.name}>
                    <NavLink to={`/store/shop?cat=${encodeURIComponent(c.name)}`} onClick={() => setMenuOpen(false)} className={linkCls}>{c.name}</NavLink>
                    {(c.children || []).map((s) => (
                      <NavLink key={s.name} to={`/store/shop?cat=${encodeURIComponent(c.name)}&sub=${encodeURIComponent(s.name)}`} onClick={() => setMenuOpen(false)}
                        className={`${linkCls({ isActive: false })} pl-7 text-xs`}>— {s.name}</NavLink>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </nav>
        )}
      </header>

      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>

      <footer className="bg-slate-900 text-slate-300 pt-12 pb-24 md:pb-10 border-t border-slate-800 mt-8">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-lg bg-emerald-700 flex items-center justify-center"><Cross className="w-4 h-4 text-emerald-200" /></span>
              <span className="font-display font-bold text-white">Trustmeds Pharma</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">{SHOP.tagline} — Kashipur ki apni licensed medical store. 100% genuine medicines, fair ₹ prices, direct local support.</p>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-emerald-400 mb-3">Quick Links</div>
            <div className="flex flex-col gap-2 text-sm">
              {NAV.map((n) => <Link key={n.to} to={n.to} className="hover:text-white transition-colors">{n.label}</Link>)}
              <Link to="/login" className="hover:text-white transition-colors text-slate-500">Staff Login</Link>
            </div>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-emerald-400 mb-3">Contact</div>
            <div className="space-y-2 text-sm">
              <a href={`tel:+91${SHOP.phone}`} className="flex items-center gap-2 hover:text-white"><Phone className="w-4 h-4 text-emerald-500 shrink-0" /> {SHOP.phoneDisplay}</a>
              <a href={`mailto:${SHOP.email}`} className="flex items-center gap-2 hover:text-white break-all"><Mail className="w-4 h-4 text-emerald-500 shrink-0" /> {SHOP.email}</a>
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" /> <span>{SHOP.address}</span></div>
            </div>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-emerald-400 mb-3">Store Hours</div>
            <div className="flex items-center gap-2 text-sm"><Clock className="w-4 h-4 text-emerald-500 shrink-0" /> {SHOP.hours}</div>
            <p className="text-xs text-slate-500 mt-4 leading-relaxed">We dispense 100% genuine medicines. Scheduled (Rx) drugs require a valid doctor's prescription — our pharmacist will call to confirm every online order.</p>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 mt-10 pt-6 border-t border-slate-800 text-xs text-slate-500 flex flex-wrap justify-between gap-2">
          <span>© {new Date().getFullYear()} Trustmeds Pharma, Kashipur</span>
          <span>Cash on Delivery • UPI on Delivery • Pay on Pickup</span>
        </div>
      </footer>

      <a href={SHOP.whatsapp} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn"
        className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white px-4 py-3 rounded-full shadow-xl transition-transform hover:scale-105 font-medium text-sm">
        <MessageCircle className="w-5 h-5" /> WhatsApp Order
      </a>

      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 grid grid-cols-3 shadow-lg">
        <a href={`tel:+91${SHOP.phone}`} className="flex flex-col items-center gap-1 py-2.5 text-emerald-900" data-testid="mobile-call-btn">
          <Phone className="w-5 h-5" /><span className="text-[10px] font-semibold">Call</span>
        </a>
        <a href={SHOP.whatsapp} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-1 py-2.5 text-[#1EBE5D]" data-testid="mobile-whatsapp-btn">
          <MessageCircle className="w-5 h-5" /><span className="text-[10px] font-semibold">WhatsApp</span>
        </a>
        <Link to="/store/cart" className="flex flex-col items-center gap-1 py-2.5 text-slate-700 relative" data-testid="mobile-cart-btn">
          <ShoppingCart className="w-5 h-5" />
          {count > 0 && <span className="absolute top-1 right-6 w-4 h-4 rounded-full bg-amber-500 text-white text-[9px] font-bold flex items-center justify-center">{count}</span>}
          <span className="text-[10px] font-semibold">Cart</span>
        </Link>
      </div>

      <ChatWidget />

      {installEvt && !installDismissed && (
        <div className="fixed bottom-20 md:bottom-6 left-4 right-4 sm:left-auto sm:right-24 sm:w-96 z-50 bg-[#064E3B] text-white rounded-2xl shadow-2xl p-4 flex items-start gap-3" data-testid="install-app-banner">
          <img src="/icons/icon-192.png" alt="Trustmeds app" className="w-12 h-12 rounded-xl shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-bold text-sm">Trustmeds Pharma App</div>
            <div className="text-xs text-emerald-100 mt-0.5">Install on your home screen — order and track medicines in one tap!</div>
            <div className="flex items-center gap-2 mt-2.5">
              <button onClick={installApp} data-testid="install-app-btn" className="bg-white text-emerald-900 text-xs font-bold px-4 py-2 rounded-full hover:bg-emerald-50 transition-colors">Install App</button>
              <button onClick={() => { setInstallDismissed(true); localStorage.setItem("tm_install_dismissed", "1"); }} data-testid="install-dismiss-btn" className="text-emerald-200 hover:text-white text-xs px-2 py-2 transition-colors">Not now</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
